'use client'

import {
	Carousel,
	CarouselContent,
	CarouselItem,
} from '@cocoonspace/ui/components/carousel'
import { TwicImg } from '@twicpics/components/react'
import Autoplay from 'embla-carousel-autoplay'

export const HomeIntroCarousel = () => (
	<Carousel
		className='w-full'
		opts={{ loop: true }}
		plugins={[Autoplay()]}
	>
		<CarouselContent className='m-0 size-full h-[70vh] md:h-screen'>
			{Array.from({ length: 3 }).map((_, index) => (
				<CarouselItem
					key={index}
					className='size-full p-0'
				>
					<TwicImg
						alt=''
						className='z-0 h-full w-full object-cover'
						focus='auto'
						ratio='none'
						src={`/content/home/carousel-${index + 1}.jpg`}
					/>
				</CarouselItem>
			))}
		</CarouselContent>

		<div className='to-primary/10 absolute inset-0 bg-gradient-to-b from-black/50 to-40% md:bg-gradient-to-r' />
	</Carousel>
)
